import React from 'react';
import Link from 'next/link';
import round from 'lodash/round';
import { useRouter } from 'next/navigation';
import Tooltip from '@mui/material/Tooltip';
import GeneralChart from '../GeneralChart';
import { Liquid } from '@/components/AsyncComponent';
import SvgHelp from './SvgHelp';
import { COMPETITIVE_SCORE_INTRO } from '@/constants/job-title';
import { CityContext } from '@/context/create-context';

const NearCity = () => {
  const { name, adjacent_cities_by_competitive_rate = [] } =
    React.useContext(CityContext);
  const router = useRouter();

  return (
    <GeneralChart
      title={`${name}薪资竞争力分析`}
      subTip={`选取近六个月平均月薪与${name}相近的8个城市进行对比。`}
    >
      <div className="my-4">
        <table className="w-full table-fixed text-sm text-center">
          <thead className="font-semibold">
            <tr>
              <th className="text-left p-2 pl-6">城市</th>
              <th className="p-2">职位数</th>
              <th className="p-2">平均月薪</th>
              <th className="p-2">
                城市平均月租
                <br />
                （两居室）
              </th>
              <th className="p-2 flex items-center">
                <span>谈职薪资竞争力指数</span>
                <Tooltip
                  title={
                    <div className="text-primary text-opacity-85">
                      <p className="text-sm">
                        <strong>谈职薪资竞争力指数：</strong>
                        <br />
                        指用本职位的薪资在此城市生活的舒适度，指数越高代表该职位在此城市的竞争力越高
                      </p>
                      <p className="mt-3 leading-5">
                        我们的计算方式：
                        <br />
                        {COMPETITIVE_SCORE_INTRO}
                      </p>
                    </div>
                  }
                  disableTouchListener={true}
                  placement="right"
                  className="ml-2 hidden tablet:inline-block"
                  PopperProps={{
                    sx: {
                      '.MuiTooltip-tooltip': {
                        background: '#fff',
                        boxShadow: '0px 8px 15px rgba(0, 0, 0, 0.15)',
                        borderRadius: '4px',
                        maxWidth: '430px',
                        padding: '8px 20px',
                        margin: 0,
                        marginLeft: '17px !important',
                      },
                    },
                  }}
                >
                  <i className="cursor-pointer">
                    <SvgHelp />
                  </i>
                </Tooltip>
              </th>
            </tr>
          </thead>
          <tbody>
            {adjacent_cities_by_competitive_rate?.map(
              (
                {
                  name,
                  rank,
                  pinyin,
                  avg,
                  rate,
                  current_city,
                  job_count,
                  rent_price,
                },
                index,
              ) => (
                <tr
                  key={index}
                  data-selected={current_city}
                  className="border-b border-web-tertiary cursor-pointer transition-colors duration-200 hover:bg-denim/4 hover:font-semibold data-[selected=true]:bg-denim/4 data-[selected=true]:font-semibold"
                  onClick={() => router.push(`/${pinyin}/`)}
                >
                  <td className="p-2">
                    <div className="flex items-center">
                      <span
                        className={`font-semibold ${
                          current_city
                            ? 'text-web-orange-600'
                            : index === 0
                              ? 'text-web-earth-600'
                              : 'text-web-grey-550'
                        } mr-1 tablet:mr-2.5`}
                      >
                        {rank}
                      </span>
                      <Link
                        title={name}
                        href={`/${pinyin}/`}
                        className="underline line-clamp-1"
                      >
                        {name}
                      </Link>
                    </div>
                  </td>
                  <td className="p-2">{job_count}</td>
                  <td className="p-2">{avg}</td>
                  <td className="p-2">{`¥${round((rent_price || 0) * 70, -2)}`}</td>
                  <td className="p-2">
                    <Liquid value={round(rate * 100, 1)} />
                  </td>
                </tr>
              ),
            )}
          </tbody>
        </table>
      </div>
    </GeneralChart>
  );
};

export default NearCity;
